import React from 'react';

import { badgeVariants } from './ui/badge';
import { formatNumber } from '../lib/formatters';
import { cn } from '../lib/utils';

export interface CountBadgeProps {
  count: number;
  className?: string;
}

/**
 * "N things are waiting for a person" — pending template reviews. Info-tinted,
 * tabular numbers, and nothing at all at 0 (nothing waiting is not news).
 *
 * Never a quantity shown as data (deletion blockers, member counts): those are
 * plain right-aligned `formatNumber` text, not pills.
 *
 * A `<span>`, not the `<div>` Badge, because it sits inside buttons (a
 * ListFilter trigger).
 */
export const CountBadge: React.FC<CountBadgeProps> = ({ count, className }) => {
  if (!(count > 0)) return null;
  return (
    <span className={cn(badgeVariants({ variant: 'info' }), 'shrink-0 tabular-nums', className)} data-count-badge="">
      {formatNumber(count)}
    </span>
  );
};
